"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_1 = require("./styled");

var mixins_1 = require("../../styles/mixins");

var Overlay = function Overlay(_a) {
  var isOpen = _a.isOpen,
      transparent = _a.transparent,
      onClick = _a.onClick,
      zIndex = _a.zIndex,
      position = _a.position,
      className = _a.className,
      cursor = _a.cursor;

  if (!isOpen) {
    return null;
  }

  return react_1.default.createElement(styled_1.OverlayWithBackground, {
    onClick: onClick,
    className: className,
    "$zIndex": zIndex,
    "$transparent": transparent,
    "$position": position,
    "$cursor": cursor
  });
};

Overlay.defaultProps = {
  zIndex: mixins_1.zIndex.local,
  position: 'fixed'
};
exports.default = Overlay;